// extracted by mini-css-extract-plugin
export default {"socialMedia":"social_socialMedia__n+NBS","socialContainer":"social_socialContainer__W2ZgT","payxInfo":"social_payxInfo__aWxc0"};